import {createStore, applyMiddleware, combineReducers} from 'redux'
import createSagaMiddleware from 'redux-saga'
import { reducer as form } from 'redux-form';
import {reducerUsuario,reducerSesion} from './reducers/reducerlogin'
import {reducerUsuarios} from './reducers/reducerUsuarios'
import {reducerConfig} from './reducers/reducerconfig'
import {reducerOrdenes} from './reducers/reducerOrdenes'
import {reducerCatalogo} from './reducers/reducerCatalogo'
import {reducerClientes} from './reducers/reducerClientes'
import {reducerProductos, reducerFileProduct} from './reducers/reducerProductos'
import SagasUsuario from './sagas/sagasUsuario'
import SagasConfig from './sagas/sagasConfig';
import SagasOrdenes from './sagas/sagasOrdenes';
import SagasCatalogo from './sagas/sagasCatalogo';
import SagasClientes from './sagas/sagasClientes';
import SagasProductos from './sagas/sagasProductos';
import SagasFileProduct from './sagas/sagasFileProduct'

const reducerYouMagazine= combineReducers({
    reducerConfig,
    reducerSesion,
    reducerUsuario,
    reducerUsuarios,
    reducerOrdenes,
    reducerCatalogo,
    reducerClientes,
    reducerProductos,
    reducerFileProduct,
    form
})

const sagaMiddleware=createSagaMiddleware()
const store =createStore(reducerYouMagazine, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(SagasUsuario)
sagaMiddleware.run(SagasConfig)
sagaMiddleware.run(SagasOrdenes)
sagaMiddleware.run(SagasCatalogo)
sagaMiddleware.run(SagasClientes)
sagaMiddleware.run(SagasProductos)
sagaMiddleware.run(SagasFileProduct)

export default store